import React, { useEffect } from 'react';
import { KeyboardManager, KeyState } from './Keyboard';

interface KeyboardProps {
    onKeyClick: (letter: string) => void
    onDeleteKeyClick: () => void
    onEnterKeyClick: () => void
    keyboardManager: KeyboardManager
}

const row_one = ["Q", "W", "E", "R", "T", "Y", "U", "I", "O", "P"]
const row_two = ["A", "S", "D", "F", "G", "H", "J", "K", "L"]
const row_three = ["Z", "X", "C", "V", "B", "N", "M"]


export default function Keyboard({onKeyClick, onDeleteKeyClick, onEnterKeyClick, keyboardManager}: KeyboardProps) {
    const getKeyButton = (letter: string) => {
        const keyState = keyboardManager.getKeyState(letter);
        let stateClass = "";
        if (keyState === KeyState.Correct) {
            stateClass = "correct"
        } else if (keyState === KeyState.WrongSpot)  {
            stateClass = "wrong-spot"
        } else if (keyState === KeyState.Incorrect)  {
            stateClass = "incorrect"
        } else if (keyState === KeyState.Unused)  {
            stateClass = "neutral"
        } else {
            stateClass = 'OFF'
        }
        return (
            <button onClick={() => onKeyClick(letter)} className={"keeb-square " + stateClass}>
                <p className={"keeb-letter"}>{ letter }</p>
            </button>
        )
    }

    //Event listener for when the page first loads
    // useEffect(() => {
    //     const handleKeyPress = (event: KeyboardEvent) => {
    //     }
    //     document.addEventListener("keydown", handleKeyPress);

    //     return () => {}}, []);
    //         document.removeEventListener("keydown", handleKeyPress);
    //     };
    // }, []);

    return (

        //  <button onClick={() => onKeyClick("Q")} className="keeb-square">

        <div className="keeb-container">
            <div className="keeb-row">
                {row_one.map((letter) => getKeyButton(letter))}
            </div>

            <div className="keeb-row">
                {row_two.map((letter) => getKeyButton(letter))}
            </div>

            <div className="keeb-row">
                <button onClick={() => onEnterKeyClick()} className="keeb-send neutral">
                    <p className="keeb-send-letter submit">SUBMIT</p>
                </button>
                {row_three.map((letter) => getKeyButton(letter))}
                <button onClick={() => onDeleteKeyClick()} className="keeb-send neutral">
                    <p className="keeb-send-letter backspace">BACKSPACE</p>
                </button>
            </div>

        </div>

    )
}